<configuration-option-other-card
  [formValues]="configFormValues$ | async"
  (onSubmit)="onSubmit($event)"
></configuration-option-other-card>
